var d = Date.now();
let date = new Date(d);
export let dateNow = date.toLocaleString('en-GB', {
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric',
})